import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./index.scss";
import RealisationService from "../../services/realisation/realisation.service";
import { Container } from "react-bootstrap";
import Header from "../../components/appLayout/header";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO";

const realisationService = new RealisationService();

export const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const apiUrl = process.env.REACT_APP_API_URL || "";

  const getImageURL = (imageName) =>
    imageName
      ? `${apiUrl.replace(/\/$/, "")}/blogs/${imageName}/image`
      : "/default-blog.png";

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await realisationService.getRealisationById(id);
        setBlog(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement du blog :", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [id]);

  if (loading) return <p>{t("blogDetails.loading")}</p>;
  if (!blog) return <p>{t("blogDetails.notFound")}</p>;

  // Extraire le texte du HTML pour la description
  const getTextFromHTML = (html) => {
    if (typeof window === "undefined") return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    return text.replace(/\s+/g, " ").trim();
  };

  const blogDescription = blog.description
    ? getTextFromHTML(blog.description).substring(0, 160) + "..."
    : "Article de blog MSIT Conseil sur la transformation digitale et les technologies.";

  return (
    <div className="blog-details-container mb-0">
      <SEO
        title={`${blog.title} - MSIT Conseil`}
        description={blogDescription}
        keywords={`${blog.title}, MSIT Conseil, transformation digitale, blog`}
        url={`https://www.msit-conseil.fr/blogDetails/${id}`}
        image={getImageURL(blog._id)}
        type="article"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "Blog", url: "https://www.msit-conseil.fr/blogs" },
          { name: blog.title, url: `https://www.msit-conseil.fr/blogDetails/${id}` }
        ]}
      />
      <Header stylebg={"bg-color"} />
      <Container>
        <div className="blog-details-header mt-5">
          {t("blogDetails.article")}
        </div>
        <div className="blog-details-title mt-3">{blog.title}</div>

        <div className="blog-details-image mt-5">
          <img
            className="img-fluid"
            src={getImageURL(blog._id)}
            alt={blog.title}
          />
        </div>

        <div
          className="blog-details-content mt-5"
          dangerouslySetInnerHTML={{ __html: blog.description }}
        />
      </Container>
    </div>
  );
};
